import {
  APIConnectionConfig,
  ModuleConfig,
  ModuleDisplayConfig,
  ModuleMapConfig,
} from '@schamburg-web/interfaces';
import { eventImpactSort } from '../utils';
import RoadworkDisplayCard from './RoadworkDisplayCard';
import RoadworkMarker from './RoadworkMarker';

export const roadworkIcon = '/mapicons/plannedlaneclosure.svg';

const mapModuleConfig: ModuleMapConfig = {
  zIndex: 80,
  layerIcon: roadworkIcon,
  showOnMap: true,
  defaultEnabled: true,
  wmsMapLayer: {
    server: import.meta.env.VITE_REACT_APP_GEOSERVERURL + '/wms?',
    args: {
      LAYERS: ['lake:roadworkoverlays'],
      STYLES: [],
      SRS: 'EPSG:900913',
    },
  },
};

const displayConfig: ModuleDisplayConfig = {
  label: 'Roadwork',
  isPopupDialog: false,
  isMobilePopupDialog: true,
  isOnSideBar: true,
  popupDef: RoadworkDisplayCard,
  cardDef: RoadworkDisplayCard,
  markerDef: RoadworkMarker,
  avatarDef: roadworkIcon,
  sidebarSort: eventImpactSort,
  panTo: true,
  showMarquee: true, // Enable marquee for roadwork
};

const apiConfig: APIConnectionConfig = {
  endpoint: 'roadwork',
  updateDelay: 0,
  publishLayer: 'roadwork',
};

const moduleConfig: ModuleConfig = {
  moduleLabel: 'Roadwork',
  name: 'planned',
  mapConfig: mapModuleConfig,
  displayConfig: displayConfig,
  apiConfig: apiConfig,
};

export default moduleConfig;
